import { useNavigate } from 'react-router-dom';
import type { ArenaSummary } from '@jungles/shared';
import { useApi } from '../lib/hooks';
import {
  ErrorState,
  Header,
  JungleStrip,
  Loader,
  Screen,
  TabBar,
} from '../components/Chrome';
import { ChevronIcon } from '../components/icons';

/** A2 · Арена (SPEC §5). */

interface ArenaResponse extends ArenaSummary {
  leagues: {
    tier: number;
    name: string;
    title: string;
    icon: string;
    reached: boolean;
    current: boolean;
  }[];
}

function pluralDays(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 19) return 'дней';
  if (mod10 === 1) return 'день';
  if (mod10 >= 2 && mod10 <= 4) return 'дня';
  return 'дней';
}

export function ArenaScreen() {
  const navigate = useNavigate();
  const { data, error, loading, reload } = useApi<ArenaResponse>('/api/arena');

  return (
    <Screen tabs>
      <Header />
      <div className="row" style={{ margin: '10px 0 18px' }}>
        <h1 style={{ margin: 0 }}>Арена</h1>
        <button className="rules-btn" type="button" onClick={() => navigate('/arena/rules')}>
          <i aria-hidden="true">?</i>
          Правила начисления
        </button>
      </div>

      {loading ? <Loader /> : null}
      {error ? <ErrorState message={error} onRetry={reload} compact={!!data} /> : null}

      {data ? (
        <>
          {data.personal ? (
            <button className="lgc" type="button" onClick={() => navigate('/arena/league')}>
              <img src={data.personal.icon} alt="" />
              <span>
                <b>{data.personal.name}</b>
                <small>
                  {data.personal.rank
                    ? `Вы #${data.personal.rank} из ${data.personal.size}, до конца недели ${
                        data.personal.daysLeft
                      } ${pluralDays(data.personal.daysLeft)}`
                    : `До конца недели ${data.personal.daysLeft} ${pluralDays(
                        data.personal.daysLeft,
                      )}`}
                </small>
                <em>{data.personal.zoneLabel}</em>
              </span>
              <ChevronIcon size={18} className="chev" />
            </button>
          ) : null}

          {data.gym ? (
            <button className="lgc" type="button" onClick={() => navigate('/arena/gym')}>
              <img src={data.gym.icon} alt="" />
              <span>
                <b>{data.gym.name}</b>
                <small>
                  {data.gym.gymName}
                  {data.gym.rank ? ` #${data.gym.rank} из ${data.gym.size}` : ''}, до конца
                  месяца {data.gym.daysLeft} {pluralDays(data.gym.daysLeft)}
                </small>
                <em>{data.gym.zoneLabel}</em>
              </span>
              <ChevronIcon size={18} className="chev" />
            </button>
          ) : (
            <section className="card">
              <h2>Лига залов</h2>
              <p className="nt" style={{ margin: 0 }}>
                Выберите домашний зал на экране «Тренировки» — очки пойдут в его рейтинг.
              </p>
            </section>
          )}

          <div className="secl">Все лиги</div>
          <div className="coins">
            {data.leagues.map((league) => (
              <div
                key={league.tier}
                className={`coin${league.current ? ' cur' : ''}${
                  league.reached ? '' : ' lock'
                }`}
              >
                <img src={league.icon} alt="" />
                {league.name}
              </div>
            ))}
          </div>

          <button
            className="b"
            type="button"
            style={{ marginTop: 16 }}
            onClick={() => navigate('/arena/rules')}
          >
            Правила начисления
          </button>
        </>
      ) : null}

      <JungleStrip />
      <TabBar />
    </Screen>
  );
}
